module.exports = __webpack_public_path__ + "static/media/V.27b4c255.svg";